<div class="w-full h-full min-h-full flex flex-col gap-[0.75rem]" [gcElementWidthClass]="{
    'is-small': POPUP_MINIMIZED_WIDTH_SIZE.small,
    'is-middle': POPUP_MINIMIZED_WIDTH_SIZE.middle,
    'is-big': POPUP_MINIMIZED_WIDTH_SIZE.big,
  }"
  #widthClass="gcElementWidthClass">
  @let deployment = loggerDeployment();
  @let dataAvailable = isDataExist();
  @let requestError = error();

  @if (deployment) {
    @if (!requestError) {
      <div class="grow-1 min-h-0 overflow-y-auto px-4 py-[0.75rem]">
        @if (dataAvailable) {
          <div class="flex flex-wrap gap-[0.25rem]">
            @for (picture of data(); track picture.id) {
              <gc-picture-gallery-list-item [picture]="picture" styleClass="!size-[10.375rem] !cursor-default" />
            }
          </div>
        } @else {
          <div class="flex flex-col gap-[0.75rem]">
            <div translate="@@shared-no-pictures-available_label" class="text-[0.875rem] font-[600] leading-[150%] text-(--p-primary-500)"></div>
            <div translate="@@shared-no-pictures-available_info" class="text-[0.75rem] font-[500] leading-[150%] text-(--p-gray-950)"></div>
          </div>
        }
      </div>
    } @else {
      <div class="grow-1 flex max-w-full min-w-0 min-h-0 px-4 items-center justify-center">
        <gc-floating-popup-base-error-message [isMinimized]="true" [requestError]="requestError"></gc-floating-popup-base-error-message>
      </div>
    }
  }
</div>
